import { render, staticRenderFns } from "./NewContactsEmergencyForm.vue?vue&type=template&id=678877f6&scoped=true"
import script from "./NewContactsEmergencyForm.vue?vue&type=script&lang=js"
export * from "./NewContactsEmergencyForm.vue?vue&type=script&lang=js"
import style0 from "./NewContactsEmergencyForm.vue?vue&type=style&index=0&id=678877f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678877f6",
  null
  
)

export default component.exports